document.addEventListener("DOMContentLoaded", () => {
	const signinForms = document.querySelectorAll("form.signin-form");

	if (!signinForms.length) {
		return;
	}

	signinForms.forEach((form) => {
		const responseOutput = form.querySelector(".response-output");
		const submitButton = form.querySelector('input[type="submit"]');
		const step2fa = form.querySelector(".signin-2fa-step");
		const verifyButton = form.querySelector(".signin-2fa-submit");

		// ── Step 1: credentials ──────────────────────────────────────────────

		form.addEventListener("submit", (e) => {
			e.preventDefault();
			resetValidation(form);

			const userLogin = form.querySelector('input[name="user_login"]');
			const userPass = form.querySelector('input[name="user_pass"]');
			let isValid = true;

			if (!userLogin.value.trim()) {
				setFieldError(userLogin);
				isValid = false;
			}

			if (!userPass.value.trim()) {
				setFieldError(userPass);
				isValid = false;
			}

			if (!isValid) {
				showResponse(responseOutput, mswpt_vars.required_fields_validation_error, "error");
				return;
			}

			submitButton.disabled = true;
			form.classList.add("submitting");

			const formData = new FormData(form);

			fetch(mswpt_vars.ajax_url, {
				method: "POST",
				body: formData,
			})
				.then((res) => res.json())
				.then((response) => {
					if (response.success) {
						if (response.data.requires_2fa) {
							show2FAStep(form, step2fa, submitButton, responseOutput, response.data);
							return;
						}

						handleLoginSuccess(responseOutput, response.data);
					} else {
						showResponse(responseOutput, response.data.message, "error");
						submitButton.disabled = false;
						form.classList.remove("submitting");
					}
				})
				.catch((error) => {
					console.error("Signin error:", error);
					showResponse(responseOutput, mswpt_vars.generic_error, "error");
					submitButton.disabled = false;
					form.classList.remove("submitting");
				});
		});

		// ── Step 2: 2FA verification ─────────────────────────────────────────

		if (verifyButton) {
			verifyButton.addEventListener("click", () => {
				const totpInput = form.querySelector('input[name="totp_code"]');
				const code = totpInput ? totpInput.value.trim() : "";

				if (!code) {
					setFieldError(totpInput);
					showResponse(responseOutput, mswpt_vars.required_fields_validation_error, "error");
					return;
				}

				verifyButton.disabled = true;
				step2fa.classList.add("submitting");

				const data = new FormData();
				data.append("action", "user_verify_2fa");
				data.append("nonce", form.querySelector('input[name="nonce"]').value);
				data.append("totp_code", code);
				data.append("pending_token", form.querySelector('input[name="pending_token"]').value);

				fetch(mswpt_vars.ajax_url, {
					method: "POST",
					body: data,
				})
					.then((res) => res.json())
					.then((response) => {
						if (response.success) {
							handleLoginSuccess(responseOutput, response.data);
						} else {
							showResponse(responseOutput, response.data.message, "error");
							verifyButton.disabled = false;
							step2fa.classList.remove("submitting");
						}
					})
					.catch((error) => {
						console.error("2FA verification error:", error);
						showResponse(responseOutput, mswpt_vars.generic_error, "error");
						verifyButton.disabled = false;
						step2fa.classList.remove("submitting");
					});
			});
		}
	});
});

/**
 * Show the 2FA step, hiding credentials fields.
 */
function show2FAStep(form, step2fa, submitButton, responseOutput, data) {
	form.querySelector(".fields-wrapper").style.display = "none";
	form.querySelector(".form-field.custom-checkbox").style.display = "none";
	submitButton.closest(".submit-wrapper").style.display = "none";
	form.querySelector('input[name="pending_token"]').value = data.token;

	step2fa.style.display = "block";
	step2fa.removeAttribute("aria-hidden");
	step2fa.querySelector('input[name="totp_code"]').focus();

	form.classList.remove("submitting");
	submitButton.disabled = false;

	showResponse(responseOutput, data.message, "success");
}

/**
 * Handle a successful login response: redirect or reload.
 */
function handleLoginSuccess(responseOutput, data) {
	const redirectUrl = data.redirect_url;

	if (redirectUrl && redirectUrl !== window.location.href) {
		showResponse(responseOutput, data.redirect_message, "success");
		setTimeout(function () {
			window.location.href = redirectUrl;
		}, 2000);
	} else {
		showResponse(responseOutput, data.reload_message, "success");
		setTimeout(function () {
			window.location.reload();
		}, 2000);
	}
}

/**
 * Reset validation states on all fields
 */
function resetValidation(form) {
	const wraps = form.querySelectorAll(".form-control-wrap");

	wraps.forEach((wrap) => {
		wrap.classList.remove("not-valid");
	});

	const responseOutput = form.querySelector(".response-output");

	if (responseOutput) {
		responseOutput.textContent = "";
		responseOutput.classList.remove("--success", "--error");
	}
}

/**
 * Set field error state
 */
function setFieldError(input) {
	const wrap = input.closest(".form-control-wrap");

	if (wrap) {
		wrap.classList.add("not-valid");
	}
}

/**
 * Show response message
 */
function showResponse(element, message, type) {
	if (!element) {
		return;
	}

	element.textContent = message;
	element.classList.remove("--success", "--error");
	element.classList.add("--" + type);
}
